import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

const URL_ADMIN_PARTNER_CONFIGURATIONS = `${URL_APP_ADMIN}/partner-configurations`
const URL_ADMIN_PARTNER_CONFIGURATIONS_LIST = `${URL_ADMIN_PARTNER_CONFIGURATIONS}/list`
const URL_ADMIN_PARTNER_CONFIGURATION_TYPES = `${URL_ADMIN_PARTNER_CONFIGURATIONS}/types`
const URL_ADMIN_PARTNER_CONFIGURATION_TYPES_LIST = `${URL_ADMIN_PARTNER_CONFIGURATION_TYPES}/list`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-partner-configurations'>
  | DashRouteType<'app-admin-partner-configurations-list'>
  | DashRouteType<'app-admin-partner-configuration-types'>
  | DashRouteType<'app-admin-partner-configuration-types-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-partner-configurations': URL_ADMIN_PARTNER_CONFIGURATIONS,
  'app-admin-partner-configurations-list': URL_ADMIN_PARTNER_CONFIGURATIONS_LIST,
  'app-admin-partner-configuration-types': URL_ADMIN_PARTNER_CONFIGURATION_TYPES,
  'app-admin-partner-configuration-types-list': URL_ADMIN_PARTNER_CONFIGURATION_TYPES_LIST,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
